import * as THREE from 'three';
import { webcadDefines } from '.';

/* FloorObjects/FloorsObjects
 * 各階表示制御.
 */
export class FloorObjects {
  private _objects: THREE.Object3D[];

  private _visible: boolean;

  constructor() {
    this.reset();
  }

  public reset() {
    this._objects = [];
    this._visible = true;
  }

  public add(obj: THREE.Object3D) {
    // eslint-disable-next-line no-param-reassign
    obj.visible = this._visible;
    this._objects.push(obj);
  }

  public get visible() {
    return this._visible;
  }

  public set visible(vis: boolean) {
    for (let i = 0; i < this._objects.length; i += 1) {
      this._objects[i].visible = vis;
    }
    this._visible = vis;
  }

  public get objects(): THREE.Object3D[] {
    return this._objects;
  }

  public hasLabel(label: string): boolean {
    for (let i = 0; i < this._objects.length; i += 1) {
      const obj: THREE.Object3D = <THREE.Object3D> this._objects[i];
      if (obj.userData.layer && obj.userData.layer === label) {
        return true;
      }
    }
    return false;
  }
}

/**
 * class: FloorsObjects
 */
export class FloorsObjects {
  private _floorsObjects: { [key: string]: FloorObjects };

  constructor() {
    this.reset();
  }

  public reset() {
    this._floorsObjects = {};
    this._floor = webcadDefines.Limits.maxFloor + 1;
  }

  private _floor: number;

  public get floor() {
    return this._floor;
  }

  public set floor(floor: number) {
    if (floor >= webcadDefines.Limits.roofNo) {
      for (let i = webcadDefines.Limits.maxFloor; i >= 1; i -= 1) {
        this.setVisible(`R${String(i)}`, true);
        this.setVisible(`L${String(i)}`, true);
      }
    } else {
      for (let i = webcadDefines.Limits.maxFloor; i >= 1; i -= 1) {
        const visRoof = !(i >= floor);
        this.setVisible(`R${String(i)}`, visRoof);
        const visFloor = !(i > floor);
        this.setVisible(`L${String(i)}`, visFloor);
      }
    }
    this._floor = floor;
  }

  public add(obj: THREE.Object3D, label: string) {
    const objects: FloorObjects = this._floorsObjects[label];
    if (objects === undefined) {
      this._floorsObjects[label] = new FloorObjects();
    }
    this._floorsObjects[label].add(obj);
  }

  public setVisible(label: string, visible: boolean) {
    const objects: FloorObjects = this._floorsObjects[label];
    if (objects !== undefined) objects.visible = visible;
  }

  public getVisible(label: string): boolean {
    const objects: FloorObjects = this._floorsObjects[label];
    if (objects === undefined) return false;
    return this._floorsObjects[label].visible;
  }

  public getObjects(label: string): THREE.Object3D[] {
    if (this._floorsObjects[label] !== undefined) {
      return this._floorsObjects[label].objects;
    }
    return undefined;
  }

  public hasLabel(label: string, strict?: boolean): boolean {
    const objects: FloorObjects = this._floorsObjects[label];
    if (strict !== undefined && strict && objects !== undefined) {
      return objects.hasLabel(label);
    }
    return objects !== undefined;
  }
}
